import React from 'react';
import classnames from 'classnames';
import duperbrowsePaddleStyles from './DuperbrowsePaddles.scss';
export const DuperbrowsePaddle = ({ children, className, onClick, isEnabled, dataHook })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(duperbrowsePaddleStyles['duper'], className, isEnabled && duperbrowsePaddleStyles['enabled']),
        "data-hook": dataHook
    }, isEnabled ? /*#__PURE__*/ React.createElement("a", {
        onClick: onClick
    }, children) : /*#__PURE__*/ React.createElement(React.Fragment, null, children));
};
DuperbrowsePaddle.displayName = 'DuperbrowsePaddle';
export default DuperbrowsePaddle;

//# sourceMappingURL=DuperbrowsePaddle.js.map